import kakuzukeImageSource from "../assets/kakuzuke-introduction-16x7-v1.jpg";
import loveAdviceImageSource from "../assets/love-advice-introduction-16x7-v1.jpg";
import twentyDoorsImageSource from "../assets/ten-doors-introduction-16x7-v2.png";
import { FeatureIntroductionSlide } from "./FeatureIntroductionSlide";

export const KAKUZUKE_IMAGE_SOURCE = kakuzukeImageSource;
export const TWENTY_DOORS_IMAGE_SOURCE = twentyDoorsImageSource;
export const LOVE_ADVICE_IMAGE_SOURCE = loveAdviceImageSource;
export const FEATURE_IMAGE_WIDTH = 1934;
export const FEATURE_IMAGE_HEIGHT = 846;

export function KakuzukeSlide() {
  return (
    <FeatureIntroductionSlide
      slideId="kakuzuke"
      number="01"
      title="企画紹介（格付けチェック）"
      imageSource={KAKUZUKE_IMAGE_SOURCE}
      imageWidth={FEATURE_IMAGE_WIDTH}
      imageHeight={FEATURE_IMAGE_HEIGHT}
      imageAlt="緑の幕と金色の装飾に囲まれた二つの回答席が並ぶステージ"
    />
  );
}

export function TwentyDoorsSlide() {
  return (
    <FeatureIntroductionSlide
      slideId="twenty-doors"
      number="02"
      title="企画紹介（10の扉）"
      imageSource={TWENTY_DOORS_IMAGE_SOURCE}
      imageWidth={1934}
      imageHeight={846}
      imageAlt="レンガの背景に「十の扉」の題名と観客への参加方法を記した案内"
    />
  );
}

export function LoveAdviceSlide() {
  return (
    <FeatureIntroductionSlide
      slideId="love-advice"
      number="04"
      title="企画紹介（朋優恋愛相談）"
      imageSource={LOVE_ADVICE_IMAGE_SOURCE}
      imageWidth={FEATURE_IMAGE_WIDTH}
      imageHeight={FEATURE_IMAGE_HEIGHT}
      imageAlt="ハートの光を背景に二脚の椅子とテーブルが並ぶ相談ステージ"
    />
  );
}
